const MAPBOX_KEY = "pk.eyJ1IjoiZWRlbnNlbWJsIiwiYSI6ImNsMWxlanI5djA5d2EzZXJ6YWZsNmN1YmUifQ.u1EvJhFzLEKr4C9BhQt4mQ";

export default MAPBOX_KEY;
